export default __webpack_public_path__ + "static/locron-logo-0ac4056cc987bfc63b3e61883c161fba.svg";